import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLanguage } from '@/utils/storage'
import zhCN from './locales/zh-CN'
import zhHK from './locales/zh-HK'
import enHK from './locales/en-HK'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'zh-HK': zhHK,
    'en-HK': enHK
  },
  // Preserve original format-string style: {1}, {2}, etc.
  silentTranslationWarn: true
})

export default i18n
